import { createFileRoute } from '@tanstack/react-router';
import { AdminCredentialsPage } from '../../features/directory';

export const Route = createFileRoute('/admin/credentials')({ component: AdminCredentialsPage });
